import { render, staticRenderFns } from "./inputbox.vue?vue&type=template&id=377323c4&"
import script from "./inputbox.vue?vue&type=script&lang=js&"
export * from "./inputbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports